<template>
<div class="c-step step-7">
  <div>
    <stepsCounter></stepsCounter>
    <div class="c-step-ask">
      Czy miejsce to jest odpowiednio oświetlone?
    </div>
  </div>
  <div class="c-step-answers">
    <button v-on:click="answer('Tak')">Tak</button>
    <button v-on:click="answer('Nie')">Nie</button>
  </div>
</div>
</template>

<script>
import {
  mapActions
} from 'vuex'

import stepsCounter from './../stepsCounter'

export default {
  name: 'step7',
  components: {
    'stepsCounter': stepsCounter
  },
  methods: {
    answer(answer, substep = null) {
      this.$store.dispatch('answer', {
        step: '7',
        answer: answer
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

</style>
